import api from "../api";
import { API_URL } from "../constants";

export const getOperationalStatus = async () => {
  return api.get(`${API_URL}/v1/meta/status`);
};
